/**
 * Created by lingcy on 2017/3/17.
 */
import xhr from './../xhr/'

import { ellaUrl } from '../../path.config'

class ExtendsService {
//扩展属性列表
    extendsList({data}){
        return xhr({
            method: 'post',
            url: ellaUrl+'/userextends/searchList',
            body : data
        })
    }
    //通过用户类型查出所有扩展属性
    extendsValue(typeId){
        return xhr({
            method:"get",
            url:ellaUrl+"/userextends/list/"+typeId,
        })
    }

    //扩展属性新增初始化
    initExtendsValue(id) {
        return xhr({
            method: 'get',
            url: ellaUrl+'/userextends/toAdd/'+id,
        })
    }
    //保存扩展属性
    saveExtendsValue({extendsValue}={}){
        return xhr({
            method: 'POST',
            url: ellaUrl+'/userextends/doAdd',
            body:extendsValue,
        })
    }
    //删除扩展属性
    delExtendsValue(id){
        return xhr({
            method: 'get',
            url: ellaUrl+"/userextends/doDelete/"+id,
        })
    }

}

// 实例化后再导出
export default new ExtendsService()


// WEBPACK FOOTER //
// ./modules/services/ella/extendsService.js